module.exports = new __parcel__URL__("shop_nfts_button.6120f4be.png").toString();